import {
  CHAPTERS_TAB,
  COMMENTS_TAB,
  DEEP_SEARCH_TAB,
  PLAYLIST_TAB,
  SLIDES_TAB,
  TRANSCRIPTS_TAB,
} from '@/modules/common/constants/tabs';

export const REQUEST_SIZE_SEARCH_ITEMS = 10;

export const MINIMUM_LANGUAGE_COUNT = 2;

const LANGUAGE_ANY = {
  value: '',
};

export const FILTER_CONFIG_LANGUAGE_DEFAULT = LANGUAGE_ANY;

export const TIME_ANY = {
  value: '',
};

export const TIME_24_HOURS = {
  value: 'day',
};

export const TIME_WEEK = {
  value: 'week',
};

export const TIME_MONTH = {
  value: 'month',
};

export const FILTER_CONFIG_TIME = [TIME_ANY, TIME_24_HOURS, TIME_WEEK, TIME_MONTH];

export const FILTER_CONFIG_TIME_DEFAULT = TIME_ANY;

export const DURATION_ANY = {
  value: '',
};

export const DURATION_UNDER_4 = {
  value: 'under4',
  to: 4 * 60 * 1000 - 1,
};

export const DURATION_4_TO_20 = {
  value: '4to20',
  from: 4 * 60 * 1000,
  to: 20 * 60 * 1000,
};

export const DURATION_OVER_20 = {
  value: 'over20',
  from: 20 * 60 * 1000 + 1,
};

export const FILTER_CONFIG_DURATION = [DURATION_ANY, DURATION_UNDER_4, DURATION_4_TO_20, DURATION_OVER_20];

export const FILTER_CONFIG_DURATION_DEFAULT = DURATION_ANY;

export const QUERY_SEARCH_KEY = 'q' as const;
export const QUERY_LANGUAGE_KEY = 'l' as const;
export const QUERY_TIME_KEY = 't' as const;
export const QUERY_DURATION_KEY = 'd' as const;
export const QUERY_VIDEO_START_PLAY_KEY = 'pt' as const;
export const QUERY_FOCUSED_COMMENT_KEY = 'fc' as const;
export const QUERY_SELECTED_CHIP_KEY = 'c' as const;
export const QUERY_SELECTED_CHIP_TAG_KEY = 'ct' as const;
export const QUERY_SELECTED_CHIP_IAB_KEY = 'ci' as const;

export const QUERY_SELECTED_TAB_KEY = 'tab' as const;
export const QUERY_PLAYLIST_TAB_VALUE = 'pl' as const;
export const QUERY_DEEP_SEARCH_TAB_VALUE = 'ds' as const;
export const QUERY_CHAPTERS_TAB_VALUE = 'ch' as const;
export const QUERY_TRANSCRIPTS_TAB_VALUE = 'tr' as const;
export const QUERY_COMMENTS_TAB_VALUE = 'co' as const;
export const QUERY_SLIDES_TAB_VALUE = 'sl' as const;
export const QUERY_TO_TAB_MAPPING = {
  [QUERY_PLAYLIST_TAB_VALUE]: PLAYLIST_TAB,
  [QUERY_DEEP_SEARCH_TAB_VALUE]: DEEP_SEARCH_TAB,
  [QUERY_CHAPTERS_TAB_VALUE]: CHAPTERS_TAB,
  [QUERY_TRANSCRIPTS_TAB_VALUE]: TRANSCRIPTS_TAB,
  [QUERY_COMMENTS_TAB_VALUE]: COMMENTS_TAB,
  [QUERY_SLIDES_TAB_VALUE]: SLIDES_TAB,
};
export const TAB_TO_QUERY_MAPPING = {
  [PLAYLIST_TAB]: QUERY_PLAYLIST_TAB_VALUE,
  [DEEP_SEARCH_TAB]: QUERY_DEEP_SEARCH_TAB_VALUE,
  [CHAPTERS_TAB]: QUERY_CHAPTERS_TAB_VALUE,
  [TRANSCRIPTS_TAB]: QUERY_TRANSCRIPTS_TAB_VALUE,
  [COMMENTS_TAB]: QUERY_COMMENTS_TAB_VALUE,
  [SLIDES_TAB]: QUERY_SLIDES_TAB_VALUE,
};

export const ALL_POSSIBLE_QUERY_COLLECTION = {
  [QUERY_SEARCH_KEY]: '',
  [QUERY_LANGUAGE_KEY]: FILTER_CONFIG_LANGUAGE_DEFAULT.value,
  [QUERY_TIME_KEY]: FILTER_CONFIG_TIME_DEFAULT.value,
  [QUERY_DURATION_KEY]: FILTER_CONFIG_DURATION_DEFAULT.value,
  [QUERY_VIDEO_START_PLAY_KEY]: '',
  [QUERY_SELECTED_TAB_KEY]: '',
};

export const SEARCH_QUERY_COLLECTION = {
  [QUERY_SEARCH_KEY]: '',
  [QUERY_LANGUAGE_KEY]: FILTER_CONFIG_LANGUAGE_DEFAULT.value,
  [QUERY_TIME_KEY]: FILTER_CONFIG_TIME_DEFAULT.value,
  [QUERY_DURATION_KEY]: FILTER_CONFIG_DURATION_DEFAULT.value,
};

export const ALL_POSSIBLE_QUERY_KEYS = Object.keys(ALL_POSSIBLE_QUERY_COLLECTION);
export const SEARCH_QUERY_KEYS = Object.keys(SEARCH_QUERY_COLLECTION);
